import axios from '../utils/axios';

export const allCategories = async () =>
  await axios.get(`${process.env.REACT_APP_API}/categories`);

export const allLocations = async () =>
  await axios.get(`${process.env.REACT_APP_API}/locations`);

export const allProducts = async () =>
  await axios.get(`${process.env.REACT_APP_API}/products`);

export const singleProduct = async (slug) =>
  await axios.get(`${process.env.REACT_APP_API}/product/${slug}`);

export const addProduct = async (userId, product, token) =>
  await axios.post(`${process.env.REACT_APP_API}/add-product/${userId}`, product, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const updateProduct = async (productId, product, token) =>
  await axios.put(`${process.env.REACT_APP_API}/update-product/${productId}`, product, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const updateProductStatus = async (data) =>
  await axios.put(`${process.env.REACT_APP_API}/product/update-status`, data);

export const closeProduct = async (productId) =>
  await axios.put(`${process.env.REACT_APP_API}/close-product/${productId}`);

export const addFavourite = async (productId) =>
  await axios.put(`${process.env.REACT_APP_API}/add-favourite/${productId}`);

export const removeFavourite = async (productId) =>
  await axios.put(`${process.env.REACT_APP_API}/remove-favourite/${productId}`);

export const favouriteCount = async (productId) =>
  await axios.get(`${process.env.REACT_APP_API}/product/favourite-count/${productId}`);

export const relatedProducts = async (productId) =>
  await axios.get(`${process.env.REACT_APP_API}/related-products/${productId}`);

export const searchResults = async (query) =>
  await axios.post(`${process.env.REACT_APP_API}/search-results`, query);

export const getReportedProducts = async () =>
  await axios.get(`${process.env.REACT_APP_API}/reported-products`);

export const getAllProducts = async () =>
  await axios.get(`${process.env.REACT_APP_API}/products`);

export const deleteProductImage = async (productId, imageData) =>
  await axios.post(`${process.env.REACT_APP_API}/delete-image/${productId}`, imageData);

export const getFilteredProducts = async (filters, sortBy) =>
  await axios.post(`${process.env.REACT_APP_API}/products/filter`, { filters, sortBy });

export const reportProduct = async (report) =>
  await axios.post(`${process.env.REACT_APP_API}/report-product`, report);